import React from 'react';
import { getStatusOpName, InfoMode, OP_STATUS, OPERATION_TYPE } from "../../../../../util/varibles/constants";
import { getStepNameOfOp } from "../../../../../util/varibles/global";
import { IOperation2, ITreatment2 } from "../../../../../util/varibles/interface";
import DeadFish from '../../../../Operation/DeadFish';
import SiteDisease from "../../../../Operation/FishDisease/SiteDisease";
import Invoices from '../../../../Operation/Invoices';
import LiceReduction from '../../../../Operation/LiceReduction';
import MortalityIncrease from '../../../../Operation/MortalityIncrease';
import StatusGrading from '../../../../Operation/StatusGrading';
import OperationMetricsTooltip from '../../../../Tooltip/OperationMetricsTooltip';
import ActivityLog from "../../_component/AcitivtyLog";
import ApproveControl from "../../_component/ApproveControl";
import Approver from "../../_component/Approver";
import AttachFile from "../../_component/AttachFile";
import BoxOpInfo from "../../_component/BoxOpInfo";
import Columns from "../../_component/Columns";
import Duration from "../../_component/Duration";
import Status from "../../_component/Status";
import Header from "../../Header";
import { callEventPopupOpInfo, usePopupOpInfo } from '../../PopupOpInfoContext';
import stylesContainer from "../../style.module.scss";
import Tasks from "./Tasks2";

interface IProps {
    isEdit: boolean
    isApprove: boolean
    data: IOperation2<ITreatment2>
}

const Treatment: React.FC<IProps> = (props) => {
    const {
        data,
        isEdit,
        isApprove,
    } = props;
    const [real_sub_operations] = usePopupOpInfo(state => state.data?.operation.real_sub_operations);
    const [mortality_increase] = usePopupOpInfo(state => state.data?.operation.mortality_increase);
    const [lice_reduction] = usePopupOpInfo(state => state.data?.operation.lice_reduction);
    const [infoMode] = usePopupOpInfo(state => state.infoMode);
    const { updateNote, changeState } = callEventPopupOpInfo();
    const { operation, activity_log } = data;
    const totalFishAmount = (real_sub_operations ?? []).reduce(
        (total, subOperation) => total + (subOperation.fish_amount ?? 0),
        0,
    );

    const { current_process, status, files = [] } = operation;
    const statusText = status === OP_STATUS.PROCESSING ? getStepNameOfOp[OPERATION_TYPE.TREATMENT]({
        current_process,
        operation,
        activity_log,
    }) : getStatusOpName(status);

    return <>
        <Header operation={operation}>
            <div className={stylesContainer.title}>
                <div className='ml-5'>
                    <Status {...{ status, statusText }} />
                </div>
            </div>
        </Header>
        <div className={stylesContainer.body}>
            <ActivityLog />

            <BoxOpInfo data={data} isEdit={isEdit} handleUpdateNote={updateNote}>
                <Columns className="mb-2" gridTemplateColumns="65fr 35fr" content={[
                    <>
                        <div className="h-[24px] flex items-center mb-[5px]">
                            <Invoices operation={operation} />
                        </div>
                        <Duration activity_log={activity_log} />
                        <AttachFile files={files} />
                        <ApproveControl {...{ isApprove, operation, handleChangeState: changeState }} />
                        <Approver operation={operation} />
                        <SiteDisease diseases={operation.diseases || []} />
                    </>,
                    infoMode === InfoMode.ACTUAL && <div className='flex flex-col gap-1 [&>div]:!items-end [&>div]:!leading-[20px]'>
                        <div className='flex items-center gap-[5px] justify-end'>
                            <OperationMetricsTooltip />
                            <StatusGrading operation={operation} />
                        </div>
                        <LiceReduction
                            value={lice_reduction}
                            valueClassName='w-full text-right text-[15px] font-semibold !leading-[18px]'
                            showDetails={false}
                            layout='vertical'
                        />
                        <MortalityIncrease
                            value={mortality_increase}
                            valueClassName='w-full text-right text-[15px] font-semibold !leading-[18px]'
                            layout='vertical'
                        />
                        <DeadFish
                            value={operation.dead_fish}
                            total={totalFishAmount}
                            valueClassName='w-full text-right text-[15px] font-semibold !leading-[18px]'
                            layout='vertical'
                            label='Σ Dead fish'
                            showPercent={operation.status === OP_STATUS.FINISHED}
                        />
                    </div>
                ]} />
                <Tasks data={{ ...data.operation, real_sub_operations }} infoMode={infoMode} isShortLabel />
            </BoxOpInfo>
        </div>
    </>;
};

export default Treatment;
